window.$ = require('jquery');

var cocktailList = {
    currentFilters: {
        search: ''
    },
    availableFilterTypes: [],
    filterConfig: {
        type: { multiSelect: false },
        flavor: { multiSelect: true },
        complexity: { multiSelect: false },
        category: { multiSelect: false }
    },
    start: 0,
    isLoading: false,

    /**
     * Initialize cocktail list functionality
     */
    init: function () {
        var self = this;
        var $cocktailList = $('.b-cocktail-list');

        if ($cocktailList.length === 0) {
            return;
        }

        // Get initial configuration
        this.$cocktailList = $cocktailList;
        this.ajaxUrl = $cocktailList.data('ajax-url');
        this.basePageSize = parseInt($cocktailList.data('page-size'), 10) || 6;
        this.customObjectTypeId = $cocktailList.data('custom-object-type-id');
        this.enableBorderRadius = $cocktailList.data('enable-border-radius') === 'true';
        this.borderRadius = $cocktailList.css('--border-radius') || '4px';
        this.useCompactLayout = $cocktailList.data('use-compact-layout') === 'true';
        this.showTypeAboveName = $cocktailList.data('show-type-above-name') === 'true';
        
        // Detect available filter types from rendered filter groups or horizontal tabs
        this.availableFilterTypes = [];
        
        // Check for horizontal tabs first
        var $horizontalTabs = $('.b-cocktail-list__horizontal-tab-btn');
        if ($horizontalTabs.length > 0) {
            $horizontalTabs.first().each(function () {
                var filterType = $(this).data('filter');
                if (filterType && self.availableFilterTypes.indexOf(filterType) === -1) {
                    self.availableFilterTypes.push(filterType);
                }
            });
        } else {
            // Check for regular filter dropdowns
            $('.b-cocktail-list__filter-category-btn').each(function () {
                var filterType = $(this).data('filter-category');
                if (filterType && self.availableFilterTypes.indexOf(filterType) === -1) {
                    self.availableFilterTypes.push(filterType);
                }
            });
        }
        
        // Initialize filters based on available filter types
        this.initializeFilters();
        
        // Adjust page size for mobile (2 columns) to ensure even number of tiles
        this.pageSize = this.getAdjustedPageSize();

        // Check if we're using horizontal tabs (single filter)
        this.useHorizontalTabs = $('.b-cocktail-list__horizontal-tabs').length > 0;
        
        // Initialize horizontal tabs if applicable
        if (this.useHorizontalTabs) {
            this.initHorizontalTabs();
        } else {
            // Initialize filter toggle
            this.initFilterToggle();
            
            // Initialize filter categories
            this.initFilterCategories();
        }
        
        // Initialize search toggle
        this.initSearchToggle();
        
        // Initialize reset filters
        this.initResetFilters();
        
        // Initialize load more
        this.initLoadMore();
        
        // Initialize search input
        this.initSearchInput();
        
        // Update selected filters display on init
        this.updateSelectedFilters();
        
        // Adjust page size on window resize
        var self = this;
        $(window).on('resize', function() {
            var newPageSize = self.getAdjustedPageSize();
            if (newPageSize !== self.pageSize) {
                self.pageSize = newPageSize;
            }
        });
    },

    /**
     * Initialize filters based on available filter types
     */
    initializeFilters: function () {
        var self = this;
        self.currentFilters = { search: '' };
        
        // Handle horizontal tabs case
        if (self.useHorizontalTabs) {
            var $firstTab = $('.b-cocktail-list__horizontal-tab-btn').first();
            if ($firstTab.length > 0) {
                var filterType = $firstTab.data('filter');
                var $activeTab = $('.b-cocktail-list__horizontal-tab-btn.is-active').first();
                if ($activeTab.length > 0) {
                    self.currentFilters[filterType] = $activeTab.data('value');
                } else {
                    // No tab selected, show all
                    self.currentFilters[filterType] = 'all';
                }
            }
        } else {
            self.availableFilterTypes.forEach(function (filterType) {
                var config = self.filterConfig[filterType];
                if (config) {
                    if (config.multiSelect) {
                        self.currentFilters[filterType + 's'] = []; // e.g., flavors
                    } else {
                        self.currentFilters[filterType] = 'all'; // e.g., type, complexity, category
                    }
                }
            });
        }
    },

    /**
     * Get adjusted page size based on screen size and layout
     * Compact layout: 2 columns desktop, 1 column mobile
     * Default layout: 3 columns desktop, 2 columns mobile
     */
    getAdjustedPageSize: function () {
        var baseSize = this.basePageSize;
        var isMobile = window.matchMedia('(max-width: 767px)').matches;
        
        if (this.useCompactLayout) {
            if (isMobile) {
                // Mobile: 1 column - any number is fine
                return baseSize;
            } else {
                // Desktop: 2 columns - round to nearest even number
                return Math.ceil(baseSize / 2) * 2;
            }
        } else {
            if (isMobile) {
                // Mobile: 2 columns - round to nearest even number
                return Math.ceil(baseSize / 2) * 2;
            } else {
                // Desktop: 3 columns - round to nearest multiple of 3
                return Math.ceil(baseSize / 3) * 3;
            }
        }
    },

    /**
     * Initialize filter toggle button (mobile only)
     */
    initFilterToggle: function () {
        var self = this;
        var $filterToggleBtn = $('.b-cocktail-list__filter-toggle-btn');
        var $filterMenu = $('.b-cocktail-list__filters-menu');
        var $filterIcon = $('.b-cocktail-list__filter-toggle-icon--filter');
        var $closeIcon = $('.b-cocktail-list__filter-toggle-icon--close');
        
        // Check if we're on mobile or desktop
        function isMobile() {
            return window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
        }
        
        // On desktop, always show menu
        if (!isMobile()) {
            $filterMenu.show();
        }
        
        $filterToggleBtn.on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            
            // Only toggle on mobile
            if (!isMobile()) {
                return;
            }
            
            var isOpen = $filterMenu.is(':visible');
            
            if (isOpen) {
                $filterMenu.slideUp();
                $filterIcon.show();
                $closeIcon.hide();
                $filterToggleBtn.removeClass('is-active');
                // Close all filter value panels
                $('.b-cocktail-list__filter-values').slideUp();
                $('.b-cocktail-list__filter-category-arrow').removeClass('is-open');
            } else {
                $filterMenu.slideDown();
                $filterIcon.hide();
                $closeIcon.show();
                $filterToggleBtn.addClass('is-active');
            }
        });
        
        // Close filter menu when clicking outside (mobile only)
        $(document).on('click', function (e) {
            if (isMobile() && 
                !$(e.target).closest('.b-cocktail-list__filters-wrapper').length && 
                !$(e.target).closest('.b-cocktail-list__selected-filters').length) {
                if ($filterMenu.is(':visible')) {
                    $filterMenu.slideUp();
                    $filterIcon.show();
                    $closeIcon.hide();
                    $filterToggleBtn.removeClass('is-active');
                    $('.b-cocktail-list__filter-values').slideUp();
                    $('.b-cocktail-list__filter-category-arrow').removeClass('is-open');
                }
            }
        });
        
        // Close filter value dropdowns when clicking outside
        $(document).on('click', function (e) {
            if (!$(e.target).closest('.b-cocktail-list__filter-group').length) {
                $('.b-cocktail-list__filter-values').slideUp();
                $('.b-cocktail-list__filter-category-arrow').removeClass('is-open');
            }
        });
        
        // Handle window resize
        $(window).on('resize', function () {
            if (!isMobile()) {
                // On desktop, always show menu
                $filterMenu.show();
            }
        });
    },

    /**
     * Initialize filter category buttons (PROSECCO, FLAVOR, COMPLEXITY)
     */
    initFilterCategories: function () {
        var self = this;
        
        // Handle remove icon clicks (X icon) for all filter types
        $(document).on('click', '.b-cocktail-list__filter-category-remove', function (e) {
            e.preventDefault();
            e.stopPropagation();
            
            var $btn = $(this).closest('.b-cocktail-list__filter-category-btn');
            var category = $btn.data('filter-category');
            var isMultiSelect = $btn.data('multi-select') === 'true';
            var config = self.filterConfig[category];
            
            if (config) {
                if (config.multiSelect || isMultiSelect) {
                    // Clear multi-select filter
                    self.currentFilters[category + 's'] = [];
                    $('.b-cocktail-list__filter-value-btn[data-filter="' + category + '"]').removeClass('is-selected');
                    if (category === 'flavor') {
                        self.updateFlavorButtonState();
                    }
                } else {
                    // Clear single-select filter
                    self.currentFilters[category] = 'all';
                    self.updateCategoryButtonText(category, 'all');
                    $('.b-cocktail-list__filter-value-btn[data-filter="' + category + '"]').removeClass('is-selected');
                }
                self.updateSelectedFilters();
                self.applyFilters();
            }
        });
        
        // Handle category button clicks to show/hide values
        $(document).on('click', '.b-cocktail-list__filter-category-btn', function (e) {
            // Don't toggle if clicking on the remove icon (handled separately)
            if ($(e.target).closest('.b-cocktail-list__filter-category-remove').length > 0) {
                return;
            }
            
            e.preventDefault();
            e.stopPropagation();
            
            var $btn = $(this);
            var category = $btn.data('filter-category');
            var $values = $('.b-cocktail-list__filter-values[data-filter-values="' + category + '"]');
            var $arrow = $btn.find('.b-cocktail-list__filter-category-arrow');
            var isVisible = $values.is(':visible');
            
            // Close all other value panels
            $('.b-cocktail-list__filter-values').not($values).slideUp();
            $('.b-cocktail-list__filter-category-arrow').not($arrow).removeClass('is-open');
            
            // Toggle current panel
            if (isVisible) {
                $values.slideUp();
                $arrow.removeClass('is-open');
            } else {
                $values.slideDown();
                $arrow.addClass('is-open');
            }
        });
        
        // Handle filter value button clicks
        $(document).on('click', '.b-cocktail-list__filter-value-btn', function (e) {
            e.preventDefault();
            e.stopPropagation();
            
            var $btn = $(this);
            var filterType = $btn.data('filter');
            var filterValue = $btn.data('value');
            var isActive = $btn.hasClass('is-selected');
            var config = self.filterConfig[filterType];
            
            if (config) {
                if (config.multiSelect) {
                    // Multi-select (e.g., flavor)
                    if (isActive) {
                        $btn.removeClass('is-selected');
                        var filterKey = filterType + 's';
                        var index = self.currentFilters[filterKey].indexOf(filterValue);
                        if (index > -1) {
                            self.currentFilters[filterKey].splice(index, 1);
                        }
                    } else {
                        $btn.addClass('is-selected');
                        var filterKey = filterType + 's';
                        if (self.currentFilters[filterKey].indexOf(filterValue) === -1) {
                            self.currentFilters[filterKey].push(filterValue);
                        }
                    }
                    // Update button state (show/hide cross)
                    if (filterType === 'flavor') {
                        self.updateFlavorButtonState();
                    }
                } else {
                    // Single select - remove other selections
                    $('.b-cocktail-list__filter-value-btn[data-filter="' + filterType + '"]').removeClass('is-selected');
                    
                    if (!isActive) {
                        $btn.addClass('is-selected');
                        self.currentFilters[filterType] = filterValue;
                        // Update button text to show selected value
                        self.updateCategoryButtonText(filterType, filterValue);
                    } else {
                        // Deselect
                        self.currentFilters[filterType] = 'all';
                        self.updateCategoryButtonText(filterType, 'all');
                    }
                }
            }
            
            self.updateSelectedFilters();
            self.applyFilters();
        });
    },

    /**
     * Initialize horizontal tabs (for single filter type)
     */
    initHorizontalTabs: function () {
        var self = this;
        
        // Get the filter type from the first tab
        var $firstTab = $('.b-cocktail-list__horizontal-tab-btn').first();
        if ($firstTab.length === 0) {
            return;
        }
        
        var filterType = $firstTab.data('filter');
        
        // Initialize filter to 'all' (show all items by default)
        self.currentFilters[filterType] = 'all';
        
        // Handle tab clicks
        $(document).on('click', '.b-cocktail-list__horizontal-tab-btn', function (e) {
            e.preventDefault();
            
            var $tab = $(this);
            var value = $tab.data('value');
            var isActive = $tab.hasClass('is-active');
            
            if (isActive) {
                // If clicking the active tab, deselect it (show all)
                $tab.removeClass('is-active');
                self.currentFilters[filterType] = 'all';
            } else {
                // Select the clicked tab
                $('.b-cocktail-list__horizontal-tab-btn').removeClass('is-active');
                $tab.addClass('is-active');
                self.currentFilters[filterType] = value;
            }
            
            // Apply filters only on user interaction
            self.applyFilters();
        });
        
        // Don't call applyFilters() on init - keep server-side rendered content
    },

    /**
     * Initialize search toggle - expands button to show input
     */
    initSearchToggle: function () {
        var self = this;
        var $searchWrapper = $('.b-cocktail-list__search-wrapper');
        var $searchBtn = $('.b-cocktail-list__search-btn');
        var $searchInput = $('.b-cocktail-list__search-input');
        var $searchIcon = $searchBtn.find('.b-cocktail-list__search-icon');
        var $searchText = $searchBtn.find('.b-cocktail-list__search-text');

        $searchBtn.on('click', function (e) {
            // Don't toggle if clicking inside the input field
            if ($(e.target).closest('.b-cocktail-list__search-input').length > 0) {
                return;
            }
            
            e.preventDefault();
            
            // Check if search is already expanded
            var isExpanded = $searchWrapper.hasClass('is-expanded');
            
            if (isExpanded) {
                // Collapse search
                $searchWrapper.removeClass('is-expanded');
                $searchInput.blur();
                // Delay to allow collapse animation
                setTimeout(function() {
                    if (!$searchWrapper.hasClass('is-expanded')) {
                        $searchIcon.show();
                        $searchText.show();
                    }
                }, 300);
            } else {
                // Expand search
                $searchIcon.hide();
                $searchText.hide();
                // Use requestAnimationFrame to ensure DOM is ready for animation
                requestAnimationFrame(function() {
                    $searchWrapper.addClass('is-expanded');
                    setTimeout(function() {
                        $searchInput.focus();
                    }, 150);
                });
            }
        });
        
        // Close search when clicking outside
        $(document).on('click', function (e) {
            if (!$(e.target).closest('.b-cocktail-list__search').length) {
                if ($searchWrapper.hasClass('is-expanded')) {
                    var searchValue = $searchInput.val().trim();
                    if (!searchValue) {
                        // Only close if there's no search value
                        $searchWrapper.removeClass('is-expanded');
                        $searchInput.blur();
                        // Delay to allow collapse animation
                        setTimeout(function() {
                            if (!$searchWrapper.hasClass('is-expanded')) {
                                $searchIcon.show();
                                $searchText.show();
                            }
                        }, 300);
                    }
                }
            }
        });
    },

    /**
     * Initialize reset filters button
     */
    initResetFilters: function () {
        var self = this;
        
        $(document).on('click', '.b-cocktail-list__reset-filter-btn', function (e) {
            e.preventDefault();
            self.resetFilters();
        });
    },

    /**
     * Update category button text to show selected value
     */
    updateCategoryButtonText: function (filterType, value) {
        var $categoryBtn = $('.b-cocktail-list__filter-category-btn[data-filter-category="' + filterType + '"]');
        var $textSpan = $categoryBtn.find('.b-cocktail-list__filter-category-text');
        var $arrow = $categoryBtn.find('.b-cocktail-list__filter-category-arrow');
        var $remove = $categoryBtn.find('.b-cocktail-list__filter-category-remove');
        var defaultLabel = $categoryBtn.data('default-label') || '';
        
        // Check if value matches the default label (reset case)
        if (value === defaultLabel || value === 'all' || value === 'PROSECCO' || value === 'COMPLEXITY') {
            // Reset to default text
            $textSpan.text(defaultLabel);
            $arrow.show();
            $remove.hide();
            $categoryBtn.removeClass('is-selected');
        } else {
            // Show selected value
            $textSpan.text(value);
            $arrow.hide();
            $remove.show();
            $categoryBtn.addClass('is-selected');
        }
    },

    /**
     * Update flavor button state (show/hide cross and add/remove selected class)
     */
    updateFlavorButtonState: function () {
        var self = this;
        var $flavorBtn = $('.b-cocktail-list__filter-category-btn[data-filter-category="flavor"]');
        var $arrow = $flavorBtn.find('.b-cocktail-list__filter-category-arrow');
        var $remove = $flavorBtn.find('.b-cocktail-list__filter-category-remove');
        
        if (self.currentFilters.flavors && self.currentFilters.flavors.length > 0) {
            // Flavors are selected - show cross, hide arrow, add selected class
            $arrow.hide();
            $remove.show();
            $flavorBtn.addClass('is-selected');
        } else {
            // No flavors selected - show arrow, hide cross, remove selected class
            $arrow.show();
            $remove.hide();
            $flavorBtn.removeClass('is-selected');
        }
    },

    /**
     * Update selected filters display
     */
    updateSelectedFilters: function () {
        var self = this;
        var $selectedFilters = $('.b-cocktail-list__selected-filters');
        $selectedFilters.empty();
        
        // Update filter value button states
        $('.b-cocktail-list__filter-value-btn').removeClass('is-selected');
        
        // Process each available filter type
        self.availableFilterTypes.forEach(function (filterType) {
            var config = self.filterConfig[filterType];
            if (config) {
                if (config.multiSelect) {
                    // Multi-select filters (e.g., flavor)
                    var filterKey = filterType + 's';
                    var selectedValues = self.currentFilters[filterKey] || [];
                    
                    if (selectedValues.length > 0) {
                        selectedValues.forEach(function (value) {
                            var $chip = $('<button>')
                                .addClass('b-cocktail-list__selected-filter-chip')
                                .attr('data-filter-type', filterType)
                                .attr('data-filter-value', value)
                                .html('<span>' + value + '</span><span class="b-cocktail-list__chip-remove">✕</span>');
                            
                            // Apply border radius if enabled
                            if (self.enableBorderRadius && self.borderRadius) {
                                $chip.css('border-radius', self.borderRadius);
                            }
                            
                            $selectedFilters.append($chip);
                            $('.b-cocktail-list__filter-value-btn[data-filter="' + filterType + '"][data-value="' + value + '"]').addClass('is-selected');
                        });
                    }
                    
                    // Update button state for flavor
                    if (filterType === 'flavor') {
                        self.updateFlavorButtonState();
                    }
                } else {
                    // Single-select filters (e.g., type, complexity, category)
                    var filterValue = self.currentFilters[filterType];
                    if (filterValue && filterValue !== 'all') {
                        self.updateCategoryButtonText(filterType, filterValue);
                        $('.b-cocktail-list__filter-value-btn[data-filter="' + filterType + '"][data-value="' + filterValue + '"]').addClass('is-selected');
                    } else {
                        self.updateCategoryButtonText(filterType, 'all');
                    }
                }
            }
        });
        
        // Handle chip removal for multi-select filters
        $(document).off('click', '.b-cocktail-list__selected-filter-chip');
        $(document).on('click', '.b-cocktail-list__selected-filter-chip', function (e) {
            e.preventDefault();
            var filterType = $(this).data('filter-type');
            var filterValue = $(this).data('filter-value');
            var config = self.filterConfig[filterType];
            
            if (config && config.multiSelect) {
                var filterKey = filterType + 's';
                var index = self.currentFilters[filterKey].indexOf(filterValue);
                if (index > -1) {
                    self.currentFilters[filterKey].splice(index, 1);
                }
                $('.b-cocktail-list__filter-value-btn[data-filter="' + filterType + '"][data-value="' + filterValue + '"]').removeClass('is-selected');
                
                if (filterType === 'flavor') {
                    self.updateFlavorButtonState();
                }
            }
            
            self.updateSelectedFilters();
            self.applyFilters();
        });
    },

    /**
     * Initialize search input handler
     */
    initSearchInput: function () {
        var self = this;
        var searchTimeout;

        $('.b-cocktail-list__search-input').on('input', function () {
            clearTimeout(searchTimeout);
            var searchValue = $(this).val().trim();
            
            searchTimeout = setTimeout(function () {
                self.currentFilters.search = searchValue;
                self.applyFilters();
            }, 300); // Debounce search
        });
    },

    /**
     * Apply filters and reload cocktails
     */
    applyFilters: function () {
        var self = this;
        
        if (self.isLoading) {
            return;
        }

        self.start = 0; // Reset to first page
        // Adjust page size before loading
        self.pageSize = self.getAdjustedPageSize();
        self.loadCocktails(true);
    },

    /**
     * Reset all filters
     */
    resetFilters: function () {
        var self = this;
        
        // Reset filters dynamically
        self.initializeFilters();

        // Reset UI
        $('.b-cocktail-list__filter-value-btn').removeClass('is-selected');
        $('.b-cocktail-list__filter-category-btn').removeClass('is-selected');
        $('.b-cocktail-list__search-input').val('');
        
        // Handle horizontal tabs reset
        if (self.useHorizontalTabs) {
            var $firstTab = $('.b-cocktail-list__horizontal-tab-btn').first();
            if ($firstTab.length > 0) {
                $('.b-cocktail-list__horizontal-tab-btn').removeClass('is-active');
                var filterType = $firstTab.data('filter');
                self.currentFilters[filterType] = 'all';
            }
        } else {
            // Reset button text to default for all filter types
            self.availableFilterTypes.forEach(function (filterType) {
                var config = self.filterConfig[filterType];
                if (config && !config.multiSelect) {
                    self.updateCategoryButtonText(filterType, 'all');
                } else if (filterType === 'flavor') {
                    self.updateFlavorButtonState();
                }
            });
        }
        
        self.updateSelectedFilters();
        
        self.applyFilters();
    },


    /**
     * Load cocktails via AJAX
     */
    loadCocktails: function (replace) {
        var self = this;
        
        if (self.isLoading) {
            return;
        }

        self.isLoading = true;
        var $grid = $('.b-cocktail-list__grid');
        var $loadMore = $('.b-cocktail-list__load-more');
        var $noResults = $('.b-cocktail-list__no-results');

        // Show loading state
        if (replace) {
            $grid.html('<div class="b-cocktail-list__loading">Loading...</div>');
        } else {
            $loadMore.find('.b-cocktail-list__load-more-btn').text('Loading...').prop('disabled', true);
        }

        // Build request parameters dynamically
        var params = {
            customObjectTypeId: self.customObjectTypeId,
            pageSize: self.pageSize,
            start: self.start,
            search: self.currentFilters.search || ''
        };

        // Add filter parameters for each available filter type
        self.availableFilterTypes.forEach(function (filterType) {
            var config = self.filterConfig[filterType];
            if (config) {
                if (config.multiSelect) {
                    var filterKey = filterType + 's';
                    var filterValues = self.currentFilters[filterKey] || [];
                    if (filterValues.length > 0) {
                        params[filterKey] = filterValues.join(',');
                    }
                } else {
                    var filterValue = self.currentFilters[filterType];
                    if (filterValue && filterValue !== 'all') {
                        params[filterType] = filterValue;
                    }
                }
            }
        });

        // Make AJAX request
        $.ajax({
            url: self.ajaxUrl,
            method: 'GET',
            data: params,
            dataType: 'json',
            success: function (response) {
                if (response.success) {
                    if (replace) {
                        $grid.empty();
                    }

                    if (response.cocktails && response.cocktails.length > 0) {
                        // Render cocktails
                        response.cocktails.forEach(function (cocktail) {
                            var $tile = self.renderCocktailTile(cocktail);
                            $grid.append($tile);
                        });

                        // Update load more button
                        if (response.hasNext) {
                            $loadMore.show();
                            $loadMore.find('.b-cocktail-list__load-more-btn')
                                .text('LOAD MORE')
                                .prop('disabled', false)
                                .data('load-more-url', response.loadMoreUrl);
                        } else {
                            $loadMore.hide();
                        }

                        $noResults.hide();
                    } else {
                        if (replace) {
                            $noResults.show();
                        }
                        $loadMore.hide();
                    }

                    // Update filter options if provided
                    if (response.filterOptions) {
                        self.updateFilterOptions(response.filterOptions);
                    }
                    
                    // Update selected filters display
                    self.updateSelectedFilters();
                } else {
                    console.error('Error loading cocktails:', response);
                    if (replace) {
                        $grid.html('<div class="b-cocktail-list__error">Error loading cocktails. Please try again.</div>');
                    }
                }
            },
            error: function (xhr, status, error) {
                console.error('AJAX error loading cocktails:', error);
                if (replace) {
                    $grid.html('<div class="b-cocktail-list__error">Error loading cocktails. Please try again.</div>');
                }
            },
            complete: function () {
                self.isLoading = false;
                if (!replace) {
                    $loadMore.find('.b-cocktail-list__load-more-btn')
                        .text('LOAD MORE')
                        .prop('disabled', false);
                }
            }
        });
    },

    /**
     * Render a single cocktail tile
     */
    renderCocktailTile: function (cocktail) {
        var self = this;
        var $tile;
        
        if (cocktail.detailUrl) {
            $tile = $('<a>').attr('href', cocktail.detailUrl).addClass('b-cocktail-tile');
        } else {
            $tile = $('<div>').addClass('b-cocktail-tile');
        }

        var $content = $('<div>').addClass('b-cocktail-tile__content');
        
        if (cocktail.imageUrl) {
            var $image = $('<div>').addClass('b-cocktail-tile__image');
            $image.append($('<img>').attr('src', cocktail.imageUrl).attr('alt', cocktail.name).attr('loading', 'lazy'));
            $tile.append($image);
        }

        // Add type first (above name) - CSS will control visibility based on data attribute
        if (cocktail.type) {
            $content.append($('<p>').addClass('b-cocktail-tile__type').text(cocktail.type));
        }

        var $name = $('<h3>').addClass('b-cocktail-tile__name').text(cocktail.name);
        
        // Apply cocktail name styling from component configuration
        // CSS variables are already set on the parent .b-cocktail-list, so they'll be inherited
        // Just need to handle italic style via data attribute
        if (self.$cocktailList && self.$cocktailList.length > 0) {
            var itemNameItalic = self.$cocktailList.data('item-name-italic');
            
            if (itemNameItalic === 'false') {
                $name.css('font-style', 'normal');
            }
        }
        
        $content.append($name);
        
        if (cocktail.complexity) {
            $content.append($('<p>').addClass('b-cocktail-tile__complexity').text(cocktail.complexity));
        }
        
        $tile.append($content);
        
        return $tile;
    },

    /**
     * Update filter options in UI
     */
    updateFilterOptions: function (filterOptions) {
        // This could be used to dynamically update filter dropdowns
        // For now, we'll keep the initial options from server-side render
    },

    /**
     * Initialize load more button
     */
    initLoadMore: function () {
        var self = this;
        
        $(document).on('click', '.b-cocktail-list__load-more-btn', function (e) {
            e.preventDefault();
            
            if (self.isLoading) {
                return;
            }

            self.start += self.pageSize;
            self.loadCocktails(false);
        });
    }
};

// Initialize on document ready
$(document).ready(function () {
    cocktailList.init();
});

